/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectWebPlan from 'modules/me/select-web-plan';
import CurrentWebPlanCard from './index/current-web-plan-card';
import WebDetailsCard from './index/web-details-card';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import Notice from 'components/notice';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import BillingDetailsCard from './index/billing-details-card';

/**
 * Style dependencies
 */
import './styles.scss';

const Subsription = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Shopify Development Plan - Tower Systems' />
            <Topbar title='Shopify Development Plan' subTitle='Manage your Shopify Development plan' selected='shopify'>
            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Your current Shopify development plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentWebPlanCard />
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
    }),
    {},
)(Subsription);
